import React from 'react';

const Footer = () => {
  return (
    <footer id="contact" className="bg-slate-900 text-white pt-20 pb-10 relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary-500 to-transparent opacity-30"></div>
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-primary-500/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Newsletter / CTA Section */}
        <div className="bg-gradient-to-br from-primary-600 to-primary-500 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between shadow-2xl shadow-primary-900/20 mb-20 relative overflow-hidden group">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>
          <div className="absolute -right-20 -top-20 w-64 h-64 bg-white/10 rounded-full blur-2xl group-hover:scale-110 transition-transform duration-700"></div>
          
          <div className="relative z-10 text-center md:text-right mb-8 md:mb-0">
            <h3 className="text-3xl md:text-4xl font-bold mb-3 text-white">
              تسويق بالعمولة
            </h3>
            <p className="text-primary-50 text-lg md:text-xl font-light">
              انضم إلى برنامج الإحالة الخاص بنا واكسب عمولات مجزية عند إحالة عملاء جدد
            </p>
          </div>
          <a 
            href="https://wa.me/966557990109?text=مرحباً، أريد الانضمام إلى برنامج الإحالة"
            target="_blank"
            rel="noopener noreferrer"
            className="relative z-10 bg-white text-primary-600 px-10 py-4 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl hover:bg-primary-50 transition-all duration-300 transform hover:-translate-y-1 inline-flex items-center gap-2"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
            انضم الآن عبر واتساب
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8 mb-16 border-b border-slate-800 pb-12">
          
          {/* Brand Column (4 cols) */}
          <div className="lg:col-span-4 space-y-6">
            <div className="flex items-center">
              <img 
                src="/logo.png" 
                alt="Cash Tec Logo" 
                className="h-12 md:h-14"
              />
            </div>
            <p className="text-slate-400 leading-relaxed text-lg">
              نقدم حلولاً تقنية مبتكرة ومتكاملة لإدارة المطاعم والمقاهي، نساعدك في تبسيط العمليات وزيادة الأرباح من خلال أنظمة ذكية وسهلة الاستخدام.
            </p>
            <div className="flex items-center space-x-reverse space-x-4 pt-4">
               <SocialLink href="https://www.tiktok.com/@cash.tec6" target="_blank" rel="noopener noreferrer" icon={<TikTokIcon />} />
               <SocialLink href="https://www.instagram.com/cash.tec" target="_blank" rel="noopener noreferrer" icon={<InstagramIcon />} />
            </div>
          </div>

          {/* Quick Links (2 cols) */}
          <div className="lg:col-span-2 lg:col-start-6">
            <h3 className="text-xl font-bold mb-6 text-white border-b-2 border-primary-500 w-fit pb-2">روابط سريعة</h3>
            <ul className="space-y-4">
              <li><FooterLink href="#home">الرئيسية</FooterLink></li>
              <li><FooterLink href="#solutions">حلولنا</FooterLink></li>
              <li><FooterLink href="#management">إدارة الأعمال</FooterLink></li>
              <li><FooterLink href="#products">المنتجات</FooterLink></li>
              <li><FooterLink href="#features">المميزات</FooterLink></li>
              <li><FooterLink href="#contact">تواصل معنا</FooterLink></li>
            </ul>
          </div>

          {/* Legal (2 cols) */}

           {/* Contact Info (3 cols) */}
          <div className="lg:col-span-3">
            <h3 className="text-xl font-bold mb-6 text-white border-b-2 border-primary-500 w-fit pb-2">تفاصيل التواصل</h3>
            <ul className="space-y-5">
              <li className="flex items-start group">
                 <div className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center text-slate-200 ml-4 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300 shrink-0">
                    <LocationIcon />
                 </div>
                 <span className="text-slate-400 group-hover:text-slate-200 transition-colors mt-2">المدينة المنورة، المملكة العربية السعودية</span>
              </li>
              <li>
                 <a href="tel:966557990109" className="flex items-center group text-slate-400 group-hover:text-slate-200 transition-colors no-underline">
                    <div className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center text-slate-200 ml-4 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300 shrink-0">
                      <PhoneIcon />
                    </div>
                    <span dir="ltr">966557990109</span>
                 </a>
              </li>
              <li>
                 <a href="https://wa.me/966557990109" target="_blank" rel="noopener noreferrer" className="flex items-center group text-slate-400 group-hover:text-slate-200 transition-colors no-underline">
                    <div className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center text-slate-200 ml-4 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300 shrink-0">
                      <WhatsAppIcon />
                    </div>
                    <span dir="ltr">واتساب: 966557990109</span>
                 </a>
              </li>
               <li>
                 <a href="mailto:cashtec0530@gmail.com" className="flex items-center group text-slate-400 group-hover:text-slate-200 transition-colors no-underline">
                    <div className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center text-slate-200 ml-4 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300 shrink-0">
                      <MailIcon />
                    </div>
                    <span className="font-mono">cashtec0530@gmail.com</span>
                 </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-right">
          <p className="text-slate-500 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} <span className="text-primary-500 mx-1">CashTek</span>. جميع الحقوق محفوظة.
          </p>
          <div className="flex items-center gap-6 text-sm text-slate-500">
          </div>
        </div>
      </div>
    </footer>
  );
};

/* Subcomponents */

const FooterLink = ({ href, children }) => (
  <a 
    href={href} 
    className="text-slate-400 hover:text-primary-500 hover:padding-r-2 transition-all duration-300 flex items-center hover:translate-x-[-5px]"
  >
    <span className="opacity-0 -mr-2 hover:opacity-100 hover:mr-2 transition-all duration-300 text-primary-500">‹</span>
    {children}
  </a>
);

const SocialLink = ({ href, icon, target = '_self', rel }) => (
  <a 
    href={href} 
    target={target}
    rel={rel}
    className="w-12 h-12 rounded-full bg-slate-800 border border-slate-600 flex items-center justify-center text-slate-200 hover:bg-primary-500 hover:border-primary-500 hover:text-white transition-all duration-300 transform hover:scale-110 hover:-translate-y-1 shadow-lg shadow-black/20"
  >
    {icon}
  </a>
);

/* Icons */

const TikTokIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const InstagramIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772 A4.902 4.902 0 015.468 2.373c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
  </svg>
);

const LocationIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
  </svg>
);

const MailIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);

export default Footer;
